/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { json, type ErrorResponse } from 'react-router-dom';

// eslint-disable-next-line @nx/enforce-module-boundaries
// import type { Combine } from '@fai/util/types';

interface JsonResponse {
  data: {
    message: string;
    redirectURL?: string;
  };
}

export type CustomJsonResponse = JsonResponse & ErrorResponse;

export const isCustomJsonResponse = (error: ErrorResponse): error is CustomJsonResponse => {
  const response = error as CustomJsonResponse;

  return typeof response.data.message === 'string';
};

/**
 * Equivalent to JsonFunction from react-router-dom
 * only data is specific
 */
type OverridedJsonFunction = (data: JsonResponse['data'], init?: number | ResponseInit) => Response;

export const customJson: OverridedJsonFunction = (data, init) =>
  json<JsonResponse['data']>(data, init);
